<template>
  <el-card class="carousel-card" :body-style="{ height: '100%' }">
    <slot></slot>
  </el-card>
</template>

<script>
export default {
  name: 'carouselCard',
};
</script>

<style scoped lang="scss">
.carousel-card {
  border-radius: 0;
  width: calc(100% - 80px);
  margin: 20px 0px;
  @include breakpoint(tablet) {
    border-radius: 4px;
    margin: 20px 20px;
  }
  @include breakpoint(wide) {
    margin: 20px $--wide-margin;;
  }
  @include breakpoint(wide-xl) {
    margin: 20px $--wide-xl-margin;
  }
}
</style>
